/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Seller_SummaryInputs */

const en_checkout_seller_summary = /** @type {(inputs: Checkout_Seller_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller and complaints`)
};

/**
* | output |
* | --- |
* | "Seller and complaints" |
*
* @param {Checkout_Seller_SummaryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_seller_summary = /** @type {((inputs?: Checkout_Seller_SummaryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Seller_SummaryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_seller_summary(inputs)
});